import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const TodoEditor = ({ item, onSave, onDelete, onClose }) => {
  const [title, setTitle] = useState(item.title);
  const [note, setNote] = useState(item.note || "");
  const [due, setDue] = useState(item.due_date || "");
  const [project, setProject] = useState(item.project_id || "__none");
  const [projects, setProjects] = useState([]);

  useEffect(() => { api.get("/projects").then((r) => setProjects(r.data)).catch(() => {}); }, []);

  const save = () => onSave({
    title: title.trim(), note: note.trim() || null, clear_note: !note.trim(),
    due_date: due || null, clear_due_date: !due,
    project_id: project === "__none" ? null : project, clear_project: project === "__none",
  });

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="todo-editor">
        <DialogHeader><DialogTitle>Edit to-do</DialogTitle><DialogDescription>Title, short note, optional due date and project reference.</DialogDescription></DialogHeader>
        <div className="space-y-3">
          <div><Label className="text-xs">Title *</Label><Input value={title} onChange={(e) => setTitle(e.target.value)} data-testid="todo-editor-title" /></div>
          <div><Label className="text-xs">Short note</Label><Textarea rows={2} maxLength={500} value={note} onChange={(e) => setNote(e.target.value)} data-testid="todo-editor-note" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="text-xs">Due date (optional)</Label><Input type="date" value={due} onChange={(e) => setDue(e.target.value)} data-testid="todo-editor-due" /></div>
            <div><Label className="text-xs">Project reference</Label>
              <Select value={project} onValueChange={setProject}><SelectTrigger data-testid="todo-editor-project"><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="__none">— none —</SelectItem>{projects.map((p) => <SelectItem key={p.project_id} value={p.project_id}>{p.project_number} · {p.customer_name}</SelectItem>)}</SelectContent></Select>
            </div>
          </div>
        </div>
        <DialogFooter className="flex sm:justify-between gap-2">
          <Button variant="ghost" className="text-red-600 hover:text-red-700" onClick={onDelete} data-testid="todo-editor-delete">Delete</Button>
          <div className="flex gap-2"><Button variant="outline" onClick={onClose}>Cancel</Button><Button onClick={save} disabled={!title.trim()} className="bg-[#2563EB] hover:bg-[#1d4ed8]" data-testid="todo-editor-save">Save</Button></div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
